<template>
  <div>
    <!-- Page Banner -->
    <section class="page-banner bgs-cover overlay pt-50 ban-h mob-ban" style="background-image: url(/assets/images/banner2.jpg)">
      <div class="container">
        <div class="banner-inner">
          <h1 class="page-title2">{{ $t('financial.bannerTitle') }} <br><span>{{ $t('financial.bannerSubtitle1') }}</span><br><span>{{ $t('financial.bannerSubtitle2') }}</span></h1>
        </div>
      </div>
    </section>

    <!-- Services Description -->
    <section>
      <div class="container ser-des" id="BankingExpertise">
        <h1 class="mt-80">{{ $t('financial.title') }}</h1>
        <p class="font-2 mt-30 mb-80 lh2 mob-ban-title">
          {{ $t('financial.description') }}
        </p>
      </div>
    </section>

    <!-- Banking Expertise -->
    <section class="featured-section bgs-cover pt-60 rpt-95 pb-60 rpb-100" style="background-image: url(/assets/images/feature/feature-bg.jpg)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-8 col-sm-10">
            <div class="section-title text-center mb-20">
              <h2>{{ $t('financial.bankingExpertise.title') }}</h2>
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/realtimepayment.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.bankingExpertise.services.realTimePayments') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/interbank.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.bankingExpertise.services.interbankPayments') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/qrpayment.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.bankingExpertise.services.qrPayments') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/payment-routing.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.bankingExpertise.services.paymentRouting') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/accounting.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.bankingExpertise.services.accountingServices') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/reconcil.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.bankingExpertise.services.reconciliation') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/bankportal.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.bankingExpertise.services.corporateBanking') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/security.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.bankingExpertise.services.compliance') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/lending.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.bankingExpertise.services.lending') }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Real-Time Payments -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 pad-btm_imp" id="RealTimePayments">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/real-time.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2>{{ $t('financial.detailedServices.realTimePayments.title') }} <span>{{ $t('financial.detailedServices.realTimePayments.titleSpan') }}</span></h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in realTimePaymentsFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Interbank Payments -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp" id="InterbankPayments">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order2">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2>{{ $t('financial.detailedServices.interbankPayments.title') }} <span>{{ $t('financial.detailedServices.interbankPayments.titleSpan') }}</span></h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in interbankPaymentsFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order1">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/interbank.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Payment Routing -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 pad-btm_imp" id="PaymentRoutingandWorkflows">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/workflow.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('financial.detailedServices.paymentRouting.titleSpan') }}</span> {{ $t('financial.detailedServices.paymentRouting.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in paymentRoutingFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Corporate Banking Portal -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp" id="CorporateBankingPortal">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order2">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2>{{ $t('financial.detailedServices.corporateBanking.title') }} <span>{{ $t('financial.detailedServices.corporateBanking.titleSpan') }}</span></h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in corporateBankingFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order1">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/bank-portal.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Compliance and Security -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 pad-btm_imp" id="ComplianceandSecurity">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/security.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2>{{ $t('financial.detailedServices.compliance.title') }} <span>{{ $t('financial.detailedServices.compliance.titleSpan') }}</span></h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in complianceFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Enterprise Expertise -->
    <section class="featured-section bgs-cover pt-60 rpt-95 pb-60 rpb-100" style="background-image: url(/assets/images/feature/feature-bg.jpg)" id="EnterpriseExpertise">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-6 col-md-8 col-sm-10">
            <div class="section-title text-center mb-20">
              <h2>{{ $t('financial.enterpriseExpertise.title') }}</h2>
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/data-management.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.dataProcessing') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/crm.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.CRMERPBusinessSolutions') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/data-e.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.dataEngineering') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/bi.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.businessIntelligence') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/structure.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.architecture') }}</h5>
              </div>
            </div>
          </div>
          <!-- <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/domain.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.domainDriven') }}</h5>
              </div>
            </div>
          </div> -->
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/api.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.microservices') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/workflow.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.processAutomation') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/legacy.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.legacyTransformation') }}</h5>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/cloud.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.cloudMigration') }}</h5>
              </div>
            </div>
          </div>
          <!-- <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/centralized.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.monitoringHub') }}</h5>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-xl-4 col-md-6">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/rbac_hub.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.rbacHub') }}</h5>
              </div>
            </div>
          </div> -->
          <!-- <div class="col-xl-12 col-md-12 dis-card">
            <div class="feature-item wow fadeInUp delay-0-2s exp-b">
              <div class="icon align-i">
                <img src="/assets/images/icon/message.png" />
              </div>
              <div class="feature-content align-c">
                <h5>{{ $t('financial.enterpriseExpertise.services.messagingSystem') }}</h5>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </section>
     <!-- Data Processing -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp bg-bg1" id="DataProcessing">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order2">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('financial.detailedServices.dataProcessing.titleSpan') }}</span> {{ $t('financial.detailedServices.dataProcessing.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in dataProcessingFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order1">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/data-p.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- CRM & ERP -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100  pad-btm_imp" id="CRMBusinessSolutions">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/crm-erp.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('financial.detailedServices.CRMERPBusinessSolutions.titleSpan') }}</span> {{ $t('financial.detailedServices.CRMERPBusinessSolutions.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in CRMERPBusinessSolutionsFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Data Engineering -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp bg-bg1" id="DataEngineering">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order2">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('financial.detailedServices.dataEngineering.titleSpan') }}</span> {{ $t('financial.detailedServices.dataEngineering.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in dataEngineeringFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order1">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/data-e.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Business Intelligence & Visualization -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp" id="BusinessIntelligence">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/business-intelligence.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('financial.detailedServices.businessIntelligence.titleSpan') }}</span> {{ $t('financial.detailedServices.businessIntelligence.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in businessIntelligenceFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Enterprise Architecture -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 pad-btm_imp" id="EnterpriseArchitectureAssessmentandDevelopment">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/architect.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('financial.detailedServices.enterpriseArchitecture.titleSpan') }}</span> {{ $t('financial.detailedServices.enterpriseArchitecture.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in enterpriseArchitectureFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Process and Workflow Automation -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp" id="ProcessandWorkflowAutomation">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order2">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2>{{ $t('financial.detailedServices.processAutomation.title') }} <span>{{ $t('financial.detailedServices.processAutomation.titleSpan') }}</span></h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in processAutomationFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order1">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/workflow-automation.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Cloud Migration Services -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 pad-btm_imp" id="CloudMigrationServices">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/cloud-migration.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('financial.detailedServices.cloudMigration.titleSpan') }}</span> {{ $t('financial.detailedServices.cloudMigration.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in cloudMigrationFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Centralized Event Monitoring Hub -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 pad-btm_imp" id="CentralizedEventMonitoringHub">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6 order2">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('financial.detailedServices.monitoringHub.titleSpan') }}</span> {{ $t('financial.detailedServices.monitoringHub.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in monitoringHubFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 order1">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img class="mar-l" src="/assets/images/services/centralized.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Legacy System Transformation -->
    <section class="about-section-eight pt-50 rpt-35 pb-50 rpb-100 bg-bg1 pad-btm_imp" id="LegacySystemTransformation">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="about-eight-images rmb-55 wow fadeInLeft delay-0-2s">
              <img src="/assets/images/services/legacy.png" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="about-eight-content wow fadeInRight delay-0-2s w-100 fin-w">
              <div class="row">
                <div class="col-xl-12">
                  <div class="section-title">
                    <h2><span>{{ $t('financial.detailedServices.legacyTransformation.titleSpan') }}</span> {{ $t('financial.detailedServices.legacyTransformation.title') }}</h2>
                  </div>
                </div>
              </div>
              <ul class="list-style-three">
                <li v-for="(feature, index) in legacyTransformationFeatures" :key="index">
                  <p v-html="feature"></p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

   

  </div>
</template>

<script>
export default {
  name: 'ServicesFinancial',
  computed: {
    realTimePaymentsFeatures() {
      return this.$tm('financial.detailedServices.realTimePayments.features')
    },
    interbankPaymentsFeatures() {
      return this.$tm('financial.detailedServices.interbankPayments.features')
    },
    paymentRoutingFeatures() {
      return this.$tm('financial.detailedServices.paymentRouting.features')
    },
    corporateBankingFeatures() {
      return this.$tm('financial.detailedServices.corporateBanking.features')
    },
    complianceFeatures() {
      return this.$tm('financial.detailedServices.compliance.features')
    },
    enterpriseArchitectureFeatures() {
      return this.$tm('financial.detailedServices.enterpriseArchitecture.features')
    },
    processAutomationFeatures() {
      return this.$tm('financial.detailedServices.processAutomation.features')
    },
    cloudMigrationFeatures() {
      return this.$tm('financial.detailedServices.cloudMigration.features')
    },
    monitoringHubFeatures() {
      return this.$tm('financial.detailedServices.monitoringHub.features')
    },
    legacyTransformationFeatures() {
      return this.$tm('financial.detailedServices.legacyTransformation.features')
    }
    ,
    dataProcessingFeatures() {
      return this.$tm('financial.detailedServices.dataProcessing.features')
    }
    ,
    CRMERPBusinessSolutionsFeatures() {
      return this.$tm('financial.detailedServices.CRMERPBusinessSolutions.features')
    }
    ,
    dataEngineeringFeatures() {
      return this.$tm('financial.detailedServices.dataEngineering.features')
    }
    ,
    businessIntelligenceFeatures() {
      return this.$tm('financial.detailedServices.businessIntelligence.features')
    }
  },
  mounted() {
    // Initialize animations
    this.$nextTick(() => {
      // WOW.js animations
      if (typeof WOW !== 'undefined') {
        new WOW().init()
      }
      
      // Handle URL hash scrolling
      this.handleHashScroll()
    })
  },
  methods: {
    handleHashScroll() {
      // Check if there's a hash in the URL
      const hash = window.location.hash
      if (hash) {
        setTimeout(() => {
          const element = document.querySelector(hash)
          if (element) {
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            })
          }
        }, 500) // Wait for page to fully load
      }
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
        // Update URL hash without triggering page reload
        history.pushState(null, null, `#${sectionId}`)
      }
    }
  },
  watch: {
    '$route'() {
      // Handle route changes (including hash changes)
      this.$nextTick(() => {
        this.handleHashScroll()
      })
    }
  }
}
</script>
